import React, { useState, useEffect, useContext } from "react";
import {
  Input,
  Label,
  Card,
  CardBody,
  FormGroup,
  Button,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationPin } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { addItemToCart } from "../../api/Cart/AddcartApi.js";
import {
  getPlantByUserId,
  getPlants,
  getProccesingCostByPlantId,
  getProcessingCostsByIdandType,
} from "../../api/processing plant/plantApi.js";
import {
  getCourierByUserId,
  getCouriers,
} from "../../api/courier/courierApi.js";
import { getProfile } from "../../api/boat_owner/boatOwnerApi.js";
import { AuthContext } from "../../pages/ExtraPages/AuthProvider";
import BoatOwnerDetailsView from "../BoatOwner/BoatOwnerDetailsView";
import PPOffCanvasComponent from "./PPOffCanvasComponent";
import CourierOffCanvasComponent from "./CourierOffCanvasComponent";
import "./RightSideContent.css";
import ProcessingPlantDetails from "./../CandidateAndCompany/ProcessingPlant/ProcessingPlantDetails";
import CourieListView from "./../CandidateAndCompany/Courier/CourieListView";
import RoundedMultiSelect from "./RoundedMultiSelect";

const RightSideContent = ({ stockData, processingCost }) => {
  const [plant, setPlant] = useState("");
  const [plantId, setPlantId] = useState("");
  const [plantList, setPlantList] = useState([]);
  const [plantdata, setPlantData] = useState("");
  const [courier, setCourier] = useState("");
  const [courierFee, setCourierFee] = useState(0);
  const [profileName, setProfileName] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [userId, setUserId] = useState("");
  const { user } = useContext(AuthContext);
  const [stockData2, setStockData2] = useState(stockData);
  const [quantity, setQuantity] = useState(0);
  const [courierId, setCourierId] = useState("");
  const [orderType, setOrderType] = useState("1");
  const [courierList, setCourierList] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [ppisOpen, setPPIsOpen] = useState(false);
  const [courierIsOpen, setCourierIsOpen] = useState(false);
  const [proccessing_type, setProccessing_type] = useState([]);
  const speciesMap = {
    "Albacore": "alb",
    "Southern-bluefin-tuna": "sbt",
    "Big-eye-tuna": "bet",
    "Yellowfin-tuna": "yft",
    "Long-tail-tuna": "ltt",
    "Skip-jack-tuna": "sjt",
    "Kawa-kawa": "kk",
    "Frigate-tuna": "ft",
    "Bullet-tuna": "bt",
    "Narrow-barred-spanish-mackerel": "nbsm",
    "Indo-pacific-king-mackerel": "ipkm",
    "Wahoo": "wh",
    "Oil-fish": "of",
    "Escolar": "esc",
    "Common-dolphinfish": "cdf",
    "Great-barracuda": "gb",
    "Rainbow-runner": "rr",
    "Rough-trigger-fish": "rtf",
    "Atlantic-pomfret": "ap",
  };

  function getFishIdByName(name) {
    return speciesMap[name] || null; // returns null if key not found
  }
  const handleOwnerClick = () => {
    if (selectedOwner !== null) {
      setShow(true);
    }
  };

  const toggleModal = () => {
    setShow(!show);
  };

  useEffect(() => {
    if (!user) return;
    setUserId(user.uid);
  }, [user]);

  const handleProcessingTypeChange = (selectedItems) => {
    if (selectedItems && selectedItems.length > 0) {
      const selectedTypes = selectedItems
        .map((item) => item.processingType)
        .join(", ");
      const totalFee = selectedItems.reduce(
        (sum, item) => sum + parseFloat(item.processingFee || 0),
        0
      );
      setStockData2((prevData) => ({
        ...prevData,
        Processing_Fee: totalFee,
        Processing_Type: selectedTypes,
        Processing_Plant_Id: plantId,
        Courier_id: courierId,
      }));
      setFormData((prev) => ({
        ...prev,
        processing: selectedTypes,
        processingFee: totalFee,
        Processing_Plant_Id: plantId,
        Courier_id: courierId,
      }));
    } else {
      setStockData2((prevData) => ({
        ...prevData,
        Processing_Fee: stockData.Processing_Fee || 0,
        Processing_Type: stockData.Processing_Type || "",
        Processing_Plant_Id: "",
        Courier_id: "",
      }));
      setFormData((prev) => ({
        ...prev,
        processing: stockData.Processing_Type || "",
        processingFee: stockData.Processing_Fee || 0,
        Processing_Plant_Id: "",
        Courier_id: "",
      }));
    }
  };

  const handleCourierChange = async (e) => {
    const selectedCourierId = e.target.value;
    setCourierId(selectedCourierId);
    try {
      const response = await getCourierByUserId(selectedCourierId);
      const data = response.data.data;
      setCourier(data.companyName);
      setFormData((prev) => ({
        ...prev,
        deliveryMethod: data.courierMethod || prev.deliveryMethod,
        shippingFee: data.courierFee || prev.shippingFee,
      }));
    } catch (error) {
      console.error("Error fetching courier data:", error);
      setCourier("");
    }
  };

  const fetchProcessingCostsByIdandType = async (PlantId) => {
    try {
      const response = await getProcessingCostsByIdandType(
        PlantId,
        getFishIdByName(stockData.Product_Name)
      );
      const processedData = response.data.map((item) => ({
        processingType: item.processingType,
        processingFee: item.processingFee,
      }));
      setProccessing_type(processedData);
    } catch (error) {
      setProccessing_type([]);
      setStockData2((prevData) => ({
        ...prevData,
        Processing_Fee: 0,
        Processing_Type: "",
      }));
      console.error("Error fetching processing costs:", error);
    }
  };

  const handlePlantChange = async (e) => {
    const selectedPlantId = e.target.value;
    setPlantId(selectedPlantId);
    fetchProcessingCostsByIdandType(selectedPlantId);
    try {
      const response = await getPlantByUserId(selectedPlantId);
      const data = response.data;
      setPlant(data.companyName);
      setPlantData(data);
    } catch (error) {
      console.error("Error fetching plant data:", error);
      setPlant("");
    }
  };

  const handleOrderTypeChange = (type) => {
    setOrderType(type);
    const defaultCourierType = "";
    const defaultCourierFee = 0;
    const defaultProcessingFee = 0;
    const defaultProcessingType = "";

    if (type === "3" || type === "4") {
      setPlantId(stockData.Processing_Plant_Id || "");
      setStockData2((prev) => ({
        ...prev,
        Processing_Fee: defaultProcessingFee,
        Processing_Type: defaultProcessingType,
      }));
      setFormData((prev) => ({
        ...prev,
        processing: defaultProcessingType,
        processingFee: defaultProcessingFee,
      }));
    }

    if (type === "2" || type === "4") {
      setCourierId("");
      setFormData((prev) => ({
        ...prev,
        deliveryMethod: defaultCourierType,
        shippingFee: defaultCourierFee,
      }));
    }

    if (type === "1") {
      setPlantId(stockData.Processing_Plant_Id || "");
      setCourierId("");
      setStockData2((prev) => ({
        ...prev,
        Processing_Fee: defaultProcessingFee,
        Processing_Type: defaultProcessingType,
      }));
      setFormData((prev) => ({
        ...prev,
        processing: defaultProcessingType,
        processingFee: defaultProcessingFee,
        deliveryMethod: defaultCourierType,
        shippingFee: defaultCourierFee,
      }));
    }
  };

  const fetchProfile = async () => {
    try {
      const response = await getProfile(stockData.Boat_Owner_Number);
      const data = response.data.data;
      setSelectedOwner(data);
      const name = data.firstName + " " + data.lastName;
      const profileImageUrl = data.profileImage || "default-profile.png";
      setProfileName(name || "N/A");
      setProfileImage(profileImageUrl || "N/A");
    } catch (error) {
      console.error("Error fetching profile data:", error);
      setProfileName("N/A");
    }
  };

  const fetchPlant = async () => {
    try {
      const response = await getPlantByUserId(stockData.Processing_Plant_Id);
      const data = response.data;
      setPlantData(data);
      setPlantId(data._id);
    } catch (error) {
      console.error("Error fetching plant data:", error);
    }
  };

  const fetchPlants = async () => {
    try {
      const response = await getPlants();
      setPlantList(
        response.data || [
          {
            id: stockData.Processing_Plant_Id,
            companyName: stockData.Processing_Plant_Name || "System Default",
          },
        ]
      );
    } catch (error) {
      console.error("Error fetching plants:", error);
      setPlantList([
        {
          id: stockData.Processing_Plant_Id,
          companyName: stockData.Processing_Plant_Name || "System Default",
        },
      ]);
    }
  };

  const fetchCourier = async () => {
    try {
      const response = await getCourierByUserId(stockData.Courier_id);
      const data = response.data;
    } catch (error) {
      console.error("Error fetching courier data:", error);
    }
  };

  const fetchCouriers = async () => {
    try {
      const response = await getCouriers();
      setCourierList(
        response.data.data || [
          {
            id: stockData.Courier_id,
            companyName: stockData.Courier_Method || "System Default",
          },
        ]
      );
    } catch (error) {
      console.error("Error fetching couriers:", error);
      setCourierList([
        {
          id: stockData.Courier_id,
          companyName: stockData.Courier_Method || "System Default",
        },
      ]);
    }
  };

  useEffect(() => {
    if (stockData?.Boat_Owner_Number) {
      fetchProfile();
    }
    fetchPlant();
    fetchPlants();
    fetchCourier();
    fetchCouriers();
    if (stockData.Minimum_Order_Quantity) {
      setQuantity(parseInt(stockData.Minimum_Order_Quantity, 10));
    }
  }, [stockData]);

  const [formData, setFormData] = useState({
    quotationNumber: "",
    quotationDate: "",
    expiryDate: "",
    buyerName: "",
    companyName: "",
    buyerEmail: "",
    buyerPhone: "",
    vesselOwnerName: stockData.Boat_Owner_Number || "",
    boatName: stockData.Boat_Number || "",
    ownerEmail: "",
    ownerPhone: "",
    fishSpecies: stockData.Product_Name || "",
    size: stockData.Size_Weight || "",
    processing: stockData.Processing_Type || "",
    packaging: "",
    qualityGrade: stockData.Quality_Grade || "",
    unitPrice: stockData.Price_per_Kg || "",
    shippingFee: stockData.Shipping_Fee || "",
    vat: "",
    totalPrice: "",
    deliveryAddress: "",
    deliveryMethod: stockData.Courier_Method || "",
    deliveryDate: "",
    paymentMethod: "",
    paymentDue: "",
    processingType: stockData.Processing_Type || "",
    quantity: stockData.Total_Available_Quantity || 0,
    avgDeliveryTime: "",
    additionalServices: "",
    trackingCapabilities: "",
    paymentMethods: "",
    highVolumeDiscounts: "",
    pricePerMile: "",
    BidPricePerUnit: "",
    TransportationCost: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePPOpen = () => {
    setPPIsOpen(true);
  };

  const handleCourierOpen = () => {
    setCourierIsOpen(true);
  };

  const handleChange2 = (e) => {
    const inputValue = e.target.value;

    // Allow empty string for clearing the field
    if (inputValue === '') {
      setQuantity('');
      setFormData((prev) => ({ ...prev, quantity: '' }));
      return;
    }

    // Parse and update the value
    const value = parseFloat(inputValue);
    if (!isNaN(value)) {
      setQuantity(value);
      setFormData((prev) => ({ ...prev, quantity: value }));
    }
  };

  const validateForm = () => {
    const errors = [];
    if ((orderType === '1' || orderType === '2') && !plantId) {
      errors.push('Please select a processing plant');
    }
    if ((orderType === '1' || orderType === '3') && !courierId) {
      errors.push('Please select a courier');
    }
    if ((orderType === '1' || orderType === '2') && !formData.processing) {
      errors.push('Please select at least one processing type');
    }
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (errors.length > 0) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: errors.join('. '),
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }
    console.log('Form submitted:', { ...formData, orderType, plantId });
    Swal.fire({
      icon: 'success',
      title: 'Submitted',
      text: 'Your order/bid has been submitted.',
      timer: 1500,
      showConfirmButton: false,
    });
  };

  const handleCartClick = async (quantity, productId) => {
    if (!user) {
      Swal.fire({
        icon: 'error',
        title: 'Authentication Required',
        text: 'Please log in to add items to the cart.',
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    // Validate quantity
    if (!quantity || quantity === '') {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Please enter a quantity',
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    if (quantity < stockData.Minimum_Order_Quantity) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: `Minimum order quantity is ${stockData.Minimum_Order_Quantity} KG`,
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    if (quantity > stockData.Total_Available_Quantity) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: `Maximum available quantity is ${stockData.Total_Available_Quantity} KG`,
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    const errors = validateForm();
    if (errors.length > 0) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: errors.join('. '),
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    const payload = {
      User_id: userId,
      Stock_id: productId,
      Weight: quantity,
      Order_Type: orderType,
      Processing_Plant_Id:
        orderType === '3' || orderType === '4'
          ? stockData.Processing_Plant_Id
          : plantId,
      Processing_Fee:
        orderType === '3' || orderType === '4'
          ? stockData.Processing_Fee
          : stockData2.Processing_Fee,
      Processing_Type:
        orderType === '3' || orderType === '4'
          ? stockData.Processing_Type
          : stockData2.Processing_Type,
      Courier_id:
        orderType === '2' || orderType === '4'
          ? stockData.Courier_id
          : courierId,
      Courier_Fee:
        orderType === '2' || orderType === '4'
          ? stockData.Courier_Fee
          : courierFee,
    };

    try {
      const response = await addItemToCart(payload);
      if (response.data.status === 1) {
        Swal.fire({
          icon: 'warning',
          title: 'Already Added',
          text: 'This item has already been added.',
          timer: 900,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: 'success',
          title: 'Successfully Added',
          text: 'The item has been successfully added.',
          timer: 900,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to add item to cart.',
        timer: 1500,
        showConfirmButton: false,
      });
    }
  };

  const items = [
    {
      stockData2,
      stockData,
      quantity,
      orderType,
      plantId,
      Processing_Fee: stockData2.Processing_Fee,
      Processing_Type: stockData2.Processing_Type,
      courierId,
    },
  ];

  const handleCheckout = () => {
    console.log('Checkout items:', items[0]);

    // Validate quantity
    if (!quantity || quantity === '') {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Please enter a quantity',
        confirmButtonText: 'Close',
        showConfirmButton: true,
        showCloseButton: true,
      });
      return;
    }

    if (quantity < stockData.Minimum_Order_Quantity) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: `Minimum order quantity is ${stockData.Minimum_Order_Quantity} KG`,
        confirmButtonText: 'Close',
        showConfirmButton: true,
        showCloseButton: true,
      });
      return;
    }

    if (quantity > stockData.Total_Available_Quantity) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: `Maximum available quantity is ${stockData.Total_Available_Quantity} KG`,
        confirmButtonText: 'Close',
        showConfirmButton: true,
        showCloseButton: true,
      });
      return;
    }

    if (items[0].stockData2.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Please select plant, processing type, and courier',
        confirmButtonText: 'Close',
        showConfirmButton: true,
        showCloseButton: true,
      });
      return;
    } else if (items[0].courierId == '') {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Please select courier',
        confirmButtonText: 'Close',
        showConfirmButton: true,
        showCloseButton: true,
      });
      return;
    } else if (
      items[0].Processing_Type == 'No' ||
      items[0].Processing_Type == ''
    ) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Please select processing type',
        confirmButtonText: 'Close',
        showConfirmButton: true,
        showCloseButton: true,
      });
      return;
    }
    items[0].courier_Fee = 0;
    localStorage.setItem('checkoutItems', JSON.stringify(items));
    window.location.href = `${window.location.origin}/checkout`;
  };

  const handleToggle = (newState) => {
    setPPIsOpen(newState);
  };

  const handleToggle2 = (newState) => {
    setCourierIsOpen(newState);
  };

  return (
    <React.Fragment>
      <div className="side-bar">
        <Card className="job-overview">
          <CardBody className="p-4">
            {/* Owner Info */}
            <div
              style={{ cursor: 'pointer' }}
              onClick={handleOwnerClick}
              className="d-flex align-items-center gap-3"
            >
              <div className="profile-container">
                <img
                  src={profileImage}
                  alt="Profile"
                />
              </div>
              <div>
                <h4 className="profile-name">{profileName}</h4>
                <p className="profile-title">Vessel Owner</p>
              </div>
            </div>

            <hr />

            {/* Certificate */}
            <div>
              <h6 className="section-title">Certificate</h6>
              <div className="d-flex flex-column gap-2">
                {selectedOwner?.EnvironmentComplianceCertificate && (
                  <p className="certificate-text">
                    Environment Compliance Certificate
                  </p>
                )}
                {selectedOwner?.VesselSafetyCertification && (
                  <p className="certificate-text">
                    Vessel Safety Certification
                  </p>
                )}
              </div>
            </div>

            <hr />

            {/* Quantity Details */}
            <h6 className="section-title">Quantity Details</h6>
            <div className="d-flex justify-content-between">
              <span className="quantity-label">Total Available Quantity</span>
              <h6 className="quantity-value">
                {stockData.Total_Available_Quantity} KG
              </h6>
            </div>
            <div className="d-flex justify-content-between">
              <span className="quantity-label">Minimum Order Quantity</span>
              <h6 className="quantity-value">
                {stockData.Minimum_Order_Quantity} KG
              </h6>
            </div>

            <hr />

            {/* Order Type */}
            <FormGroup className="order-type-checkboxes">
              <div className="d-flex flex-column">
                <div>
                  <Input
                    type="checkbox"
                    id="orderType1"
                    className="rounded-checkbox"
                    checked={orderType === '1'}
                    onChange={() => handleOrderTypeChange('1')}
                  />
                  <Label
                    htmlFor="orderType1"
                    className="ms-2 fw-bold"
                  >
                    Dispatch
                  </Label>
                  <div className="ms-4 text-muted small">
                    Please select <b>Processing Plant</b> and <b>Courier</b>.
                    <br />
                    <span className="text-primary">Commission Rate: 3%</span>
                  </div>

                  {orderType === '1' && (
                    <div className="d-flex flex-column gap-4 mt-2">
                      {/* Plant */}
                      <div className="select-group d-flex flex-column gap-2">
                        <span className="select-label">Plant</span>
                        <select
                          className="form-select"
                          onChange={handlePlantChange}
                          value={plantId}
                        >
                          <option value="">Select Plant</option>
                          {plantList.map((plant, index) => (
                            <option
                              key={index}
                              value={plant.userId}
                            >
                              {plant.companyName}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Courier */}
                      <div className="select-group d-flex flex-column gap-2">
                        <span className="select-label">Courier</span>
                        <select
                          className="form-select"
                          onChange={handleCourierChange}
                          value={courierId}
                        >
                          <option value="">Select Courier</option>
                          {courierList.map((courier, index) => (
                            <option
                              key={index}
                              value={courier.userId}
                            >
                              {courier.companyName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </FormGroup>

            <hr />

            {/* Plant & Courier Details */}
            {orderType === '1' && (
              <>
                <h6 className="section-title">Plant Details</h6>
                <div className="d-flex justify-content-between">
                  <span className="detail-label">Plant</span>
                  <h6
                    className="detail-value"
                    style={{ cursor: 'pointer' }}
                    onClick={handlePPOpen}
                  >
                    {plant}
                  </h6>
                </div>

                <span className="detail-label">Processing Types</span>
                {proccessing_type.length > 0 && (
                  <RoundedMultiSelect
                    proccessing_type={proccessing_type}
                    onChange={handleProcessingTypeChange}
                  />
                )}

                <hr />

                <h6 className="section-title">Courier Details</h6>
                <div className="d-flex justify-content-between">
                  <span className="detail-label">Courier</span>
                  <h6
                    className="detail-value"
                    style={{ cursor: 'pointer' }}
                    onClick={handleCourierOpen}
                  >
                    {courier}
                  </h6>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="detail-label">Courier Fee</span>
                  <h6 className="detail-value">{courierFee} LKR</h6>
                </div>

                <hr />
              </>
            )}

            {/* Quantity Input */}
            <ul className="list-unstyled mb-0">
              <li>
                <FormGroup>
                  <Label
                    htmlFor="quantity"
                    className="section-title"
                  >
                    Quantity
                  </Label>
                  <InputGroup>
                    <Input
                      type="number"
                      name="quantity"
                      id="quantity"
                      min={stockData.Minimum_Order_Quantity}
                      max={stockData.Total_Available_Quantity}
                      value={quantity}
                      step="1"
                      placeholder="Enter quantity (e.g., 1.5)"
                      onChange={handleChange2}
                      className="quantity-input"
                    />
                    <InputGroupText className="quantity-unit">
                      kg
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
              </li>

              {/* Buttons */}
              <li>
                <div className="d-flex flex-column flex-md-row gap-2 mt-2 w-100">
                  <Button
                    className="btn btn-hover flex-fill custom-btn-black"
                    onClick={() => handleCartClick(quantity, stockData._id)}
                  >
                    Add to Cart
                  </Button>
                  <Button
                    as={Link}
                    className="btn btn-hover flex-fill custom-btn-success"
                    onClick={handleCheckout}
                  >
                    Buy Now
                    <i className="uil uil-arrow-right ms-2"></i>
                  </Button>
                </div>
              </li>
            </ul>
          </CardBody>
        </Card>

        {/* Modals */}
        <BoatOwnerDetailsView
          isOpen={show}
          details={selectedOwner}
          toggle={toggleModal}
        />
        <PPOffCanvasComponent
          isOpen={ppisOpen}
          onToggle={handleToggle}
          plantId={plantdata._id}
        />
        <CourierOffCanvasComponent
          isOpen={courierIsOpen}
          onToggle={handleToggle2}
          courierId={courierId}
        />
      </div>
    </React.Fragment>
  );
};

export default RightSideContent;
